<div class="date-range-wrapper">
  <!-- INPUT TRIGGER -->
  <div
    class="when-input"
    [class.active]="isOpen"
    [class.has-error]="showError"
    (click)="openPicker(); $event.stopPropagation()"
  >
    <span class="input-label">When <span class="when-error"> *</span></span>
    <div class="input-content">
      <svg
        class="cal-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
      >
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <path d="M16 2v4M8 2v4M3 10h18" />
      </svg>
      <span class="input-text" [class.placeholder]="!startDate && !endDate">
        <ng-container *ngIf="startDate || endDate; else placeholder">
          <ng-container *ngIf="startDate">{{ formattedStart }}</ng-container>
          <ng-container *ngIf="!oneWay && endDate">
            – {{ formattedEnd }}</ng-container
          >
        </ng-container>
        <ng-template #placeholder>Choose your dates</ng-template>
      </span>
    </div>
  </div>

  <!-- Error message -->
  <p class="when-error" *ngIf="showError">{{ errorMessage }}</p>

  <!-- CALENDAR PANEL -->

  <div
    class="calendar-panel"
    *ngIf="isOpen"
    (click)="$event.stopPropagation()"
    [ngStyle]="customStyle"
  >
    <!-- Panel Header -->
    <div class="panel-header">
      <h3 class="panel-title">Choose your departure date</h3>
      <div class="trip-toggle">
        <span class="toggle-label-left" [class.bold]="!oneWay"
          >Return trip</span
        >
        <div
          class="toggle-track"
          [class.active]="!oneWay"
          (click)="toggleOneWay()"
        >
          <div class="toggle-thumb"></div>
        </div>
        <span class="toggle-label-right" [class.bold]="oneWay">One way</span>
      </div>
    </div>

    <!-- Calendars -->
    <div class="calendars-container">
      <!-- Prev Arrow -->
      <button
        class="nav-arrow left"
        (click)="prevMonth(); $event.stopPropagation()"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>

      <!-- Left Calendar -->
      <div class="calendar">
        <div class="month-title">
          {{ getMonthName(currentMonth) | uppercase }}
        </div>
        <div class="weekdays">
          <span *ngFor="let d of weekdays">{{ d }}</span>
        </div>
        <div class="days-grid">
          <div
            *ngFor="let day of calendarLeft"
            class="day-cell"
            [class.empty]="!day.isCurrentMonth"
            [class.past]="day.isPast && day.isCurrentMonth"
            [class.start]="day.isStart"
            [class.end]="day.isEnd"
            [class.in-range]="day.isInRange"
            [class.today]="isSameDate(day.date, today) && day.isCurrentMonth"
            (click)="selectDate(day)"
          >
            <span *ngIf="day.isCurrentMonth">{{ day.date.getDate() }}</span>
          </div>
        </div>
      </div>

      <!-- Right Calendar -->
      <div class="calendar">
        <div class="month-title">{{ getMonthName(nextMonth) | uppercase }}</div>
        <div class="weekdays">
          <span *ngFor="let d of weekdays">{{ d }}</span>
        </div>
        <div class="days-grid">
          <div
            *ngFor="let day of calendarRight"
            class="day-cell"
            [class.empty]="!day.isCurrentMonth"
            [class.past]="day.isPast && day.isCurrentMonth"
            [class.start]="day.isStart"
            [class.end]="day.isEnd"
            [class.in-range]="day.isInRange"
            [class.today]="isSameDate(day.date, today) && day.isCurrentMonth"
            (click)="selectDate(day)"
          >
            <span *ngIf="day.isCurrentMonth">{{ day.date.getDate() }}</span>
          </div>
        </div>
      </div>

      <!-- Next Arrow -->
      <button
        class="nav-arrow right"
        (click)="nextMonthClick(); $event.stopPropagation()"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>
    </div>

    <!-- Footer -->
    <div class="panel-footer">
      <button
        class="clear-btn"
        [disabled]="!startDate && !endDate"
        (click)="clearDates(); $event.stopPropagation()"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          width="14"
          height="14"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
        Clear
      </button>
      <button
        class="close-btn"
        (click)="closePicker(); $event.stopPropagation()"
      >
        Close
      </button>
    </div>
  </div>
</div>
